import { AxiosError } from 'axios';
import { getIn, useFormikContext } from 'formik';

const getResponseErrorMessage = (errors: unknown): string | undefined => {
  if (typeof errors === 'string' && errors.trim().length > 0) {
    return errors;
  }

  if (Array.isArray(errors)) {
    return errors.find(
      (value): value is string => typeof value === 'string' && value.trim().length > 0
    );
  }

  if (errors && typeof errors === 'object') {
    return Object.values(errors).find(
      (value): value is string => typeof value === 'string' && value.trim().length > 0
    );
  }

  return undefined;
};

export const raiseAxiosErrorOrDefault = (error: unknown, message: string) => {
  if (error instanceof AxiosError && error.response) {
    const responseData = error.response.data;
    const responseMessage =
      responseData && typeof responseData === 'object' && 'errors' in responseData
        ? getResponseErrorMessage(responseData.errors)
        : undefined;

    throw new Error(responseMessage ?? (message || error.message));
  }

  throw new Error(message);
};

export const useFormikError = () => {
  const { errors, touched } = useFormikContext();
  return (fieldName: string): boolean => !!getIn(errors, fieldName) && !!getIn(touched, fieldName);
};
